import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProvidersColumns from "../../../components/CustomTable/Columns/ProvidersColumns";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { useAuth } from "../../../context/AuthContext";
import { useFeedBack } from "../../../context/FeedBackContext";
import useAxios from "../../../hooks/useAxios";
import useProviders from "../../../hooks/useProviders";
import { mainPermissions } from "../../../util/MenuLinks";

const Providers = () => {

    const { permissions, isSuperAdmin } = useAuth();

    const { setCustomAlert, setLoading } = useFeedBack();

    const [filters, setFilters] = useState({
        page: 1,
        id: '',
        name: '',
        documentNumber: '',
        phoneNumber: '',
        email: '',
        address: '',
        start: '',
        end: ''
    })

    const [selectedValues, setSelectedValues] = useState([]);

    const [selectAll, setSelectAll] = useState(false);

    const [{ providers, total, numberOfPages, error: providersError, loading }, getProviders] = useProviders({ params: { ...filters } }, { useCache: false });

    const [{ error: deleteError, loading: deleteLoading }, deleteProvider] = useAxios({ method: 'DELETE' }, { manual: true, useCache: false });
    const [{ loading: loadingExport }, exportExcel] = useAxios({ url: `/providers/export/excel`, method: 'GET', responseType: 'blob' }, { manual: true, useCache: false });

    useEffect(() => {
        getProviders();
    }, [])

    useEffect(() => {
        setLoading?.({
            show: deleteLoading,
            message: 'Eliminando Proveedores'
        })
    }, [deleteLoading])

    useEffect(() => {
        if (deleteError) {
            setCustomAlert({
                title: 'error',
                severity: 'danger',
                message: 'Ha ocurrido un error al eliminar.',
                show: true
            });
        }

        if (providersError) {
            setCustomAlert({
                title: 'error',
                severity: 'danger',
                message: 'Ha ocurrido un error al obtener los proveedores.',
                show: true
            });
        }
    }, [deleteError, providersError])

    useEffect(() => {
        if (selectAll) {
            setSelectedValues(providers?.map?.((value) => value?.id))
        } else {
            setSelectedValues([])
        }
    }, [selectAll])

    const handleDelete = (value) => {
        deleteProvider({ url: `/providers/${value?.id}` }).then((data) => {
            setCustomAlert({
                title: '¡Operación Exitosa!',
                severity: 'success',
                message: 'El proveedor ha sido eliminado exitosamente.',
                show: true
            });
            getProviders();
        })
    }

    const handleSelectALL = () => {
        setSelectAll((oldSelectAll) => !oldSelectAll);
    }

    const handleSelectValue = (selectedValue) => {
        const value = selectedValues?.includes(Number(selectedValue?.id));
        if (value) {
            const newValues = selectedValues?.filter(n => n !== Number(selectedValue?.id));
            setSelectedValues(newValues);
        } else {
            setSelectedValues((oldSelectedValues) => [...oldSelectedValues, Number(selectedValue?.id)])
        }
    }

    const handlePageChange = (page) => {
        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                page: page
            }
        })
    }

    const handleDeleteSelected = () => {
        deleteProvider({ url: `/providers/multiple`, data: { ids: selectedValues } }).then((data) => {
            setCustomAlert({
                title: '¡Operación Exitosa!',
                severity: 'success',
                message: 'Los proveedores han sido eliminados exitosamente.',
                show: true
            })
            setSelectedValues([]);
            getProviders();
        });
    }

    const handleChange = (e) => {
        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                [e.target.name]: e.target.value,
                page: 1
            }
        });
    }

    const handleExportExcel = () => {
        exportExcel({ params: { ...filters } }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'proveedores.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        }).catch((err) => {
            setCustomAlert({
                title: 'error',
                severity: 'danger',
                message: 'Ha ocurrido un error al exportar a Excel.',
                show: true
            });
        });
    };

    return (
        <div>
            <div className="my-4 justify-content-end d-flex">
                <button
                    disabled={loadingExport}
                    className="btn btn-info text-white mx-1"
                    onClick={handleExportExcel}
                >
                    {loadingExport ? 'Exportando...' : 'Exportar Excel'}
                </button>
                {
                    permissions?.includes?.(mainPermissions?.providers[1]) || isSuperAdmin ?
                        <>
                            <Link to={"/proveedores/importar"} className="btn btn-success mx-2">
                                Importar proveedores
                            </Link>
                            <Link to={"/proveedores/crear"} className="btn btn-primary">
                                Crear proveedor
                            </Link>
                        </>
                        :
                        null
                }
            </div>

            <div className="row">
                <div className="col-md-4">
                    <div className="card p-4">
                        <label className="text-primary">
                            Número de proveedor
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            value={filters?.id}
                            onChange={handleChange}
                            name="id"
                            placeholder="Número de proveedor..."
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card p-4">
                        <label className="text-primary">
                            Nombre
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters?.name}
                            onChange={handleChange}
                            name="name"
                            placeholder="Nombre de proveedor..."
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card p-4">
                        <label className="text-primary">
                            Nro. de documento
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters?.documentNumber}
                            onChange={handleChange}
                            name="documentNumber"
                            placeholder="Nro. de documento..."
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card p-4">
                        <label className="text-primary">
                            Teléfono
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters?.phoneNumber}
                            onChange={handleChange}
                            name="phoneNumber"
                            placeholder="Nro. de teléfono..."
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card p-4">
                        <label className="text-primary">
                            Email
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters?.email}
                            onChange={handleChange}
                            name="email"
                            placeholder="Email..."
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card p-4">
                        <label className="text-primary">
                            Dirección
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters?.address}
                            onChange={handleChange}
                            name="address"
                            placeholder="Dirección..."
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card p-4">
                        <label className="text-primary">
                            Fecha
                        </label>
                        <div className="row">
                            <div className="col-md-6 form-group">
                                <label className="text-primary">
                                    Desde:
                                </label>
                                <input
                                    type="date"
                                    onChange={handleChange}
                                    className="form-control"
                                    name="start"
                                    value={filters?.start}
                                />
                            </div>
                            <div className="col-md-6 form-group">
                                <label className="text-primary">
                                    Hasta:
                                </label>
                                <input
                                    type="date"
                                    onChange={handleChange}
                                    className="form-control"
                                    name="end"
                                    value={filters?.end}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CustomTable
                onDeleteSelected={handleDeleteSelected}
                onSelectValue={handleSelectValue}
                onSelectAll={handleSelectALL}
                loading={loading}
                selectAll={selectAll}
                title={'Proveedores'}
                entity='providers'
                updatePath={"/proveedores"}
                onDelete={handleDelete}
                selectedValues={selectedValues}
                pages={numberOfPages}
                total={total}
                values={providers}
                currentPage={filters.page}
                collumns={ProvidersColumns}
                changePage={handlePageChange}
                perPage={filters?.perPage}
                excelUrl={'/providers/export/excel'}
                filters={filters}
                onPerPageChange={(e) => setFilters((oldFilters) => {
                    return {
                        ...oldFilters,
                        [e.target.name]: e.target.value,
                        page: 1
                    }
                })}
            />
        </div>
    )
}
export default Providers;